"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetAPILib = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const trade_token_lib_1 = require("trade_token_lib");
const trade_utils_lib_1 = require("trade_utils_lib");
const TradeAPILib_1 = require("TradeAPILib");
const Transform_1 = require("../helper/Transform");
const AssetModels_1 = require("../Models/AssetModels");
class AssetAPILib {
    constructor() {
        this.queryQuotaRules = (site, version) => {
            const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().walletApiHost}/quota_rules/`;
            return trade_utils_lib_1.ObservableUtils.getV2(url, { site: site, version: version || 0 }, undefined, true);
        };
        this.queryWithdrawLimitUsed = () => {
            const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().walletApiHost}/used_quota/`;
            return trade_utils_lib_1.ObservableUtils.getV2(url, undefined, undefined, true);
        };
    }
    sendVerifyCode(action, receiveTypes, language) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().accountServiceHost}/account/send_verification_code`;
        const body = {
            action,
            language,
            code_types: receiveTypes,
        };
        return trade_utils_lib_1.ObservableUtils.post(url, JSON.stringify(body), null, true);
    }
    // 获取与设置 是否开启只向白名单提币的状态
    getWhiteListStatus() {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().walletApiHost}/get_user_whitelist_status/`;
        return trade_utils_lib_1.ObservableUtils.getV2(url, null, null, true);
    }
    setWhiteListStatus(status, verifyInfo) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().walletApiHost}/modify_user_whitelist_status/`;
        const params = Object.assign({ modify_status: status }, verifyInfo);
        return trade_utils_lib_1.ObservableUtils.postV2(url, JSON.stringify(params), null, true);
    }
    // 获取全部地址簿地址
    getAddressBookItems() {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().walletApiHost}/get_address/`;
        return trade_utils_lib_1.ObservableUtils.getV2(url, {}, null, true);
    }
    // 获取白名单地址簿地址
    getAddressBookWhiteListItems() {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().walletApiHost}/get_whitelist_address/`;
        return trade_utils_lib_1.ObservableUtils.getV2(url, {}, null, true);
    }
    // 获取某个币的地址簿列表
    getAddressBookWithCoin(coin, chain) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().walletApiHost}/get_address_with_coin/`;
        const params = {
            coin: coin,
            chain: chain || null,
        };
        return trade_utils_lib_1.ObservableUtils.getV2(url, params, null, true);
    }
    // 增加地址到地址簿
    addAddressBookItem(AddAddressInfoData) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().walletApiHost}/add_address/`;
        return trade_utils_lib_1.ObservableUtils.postV2(url, JSON.stringify(AddAddressInfoData), null, true);
    }
    // 删除地址簿地址
    deleteAddressBookItem(params) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().walletApiHost}/delete_address/`;
        return trade_utils_lib_1.ObservableUtils.delete(url, params, null, true);
    }
    // 修改地址簿地址的备注
    modifyAddressBookItemTag(addressID, tag) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().walletApiHost}/modify_address_tag/`;
        const params = {
            address_id: addressID,
            tag: tag,
        };
        return trade_utils_lib_1.ObservableUtils.postV2(url, JSON.stringify(params), null, true);
    }
    // 修改地址簿地址的白名单状态 add为添加 remove为剔除
    modifyAddressBookItemWhiteListStatus(requestParam) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().walletApiHost}/modify_address_status/`;
        return trade_utils_lib_1.ObservableUtils.postV2(url, JSON.stringify(requestParam), null, true);
    }
    getBalanceV2$(apiKey) {
        return (0, trade_utils_lib_1.getTradeDependencyInstance)()
            .getTradingToken()
            .pipe((0, operators_1.map)((token) => {
            let urlWithCommonParam = trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().balanceApiHost}/balances_full/`, (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().commonParam);
            let headers = {
                Authorization: `Bearer ${token.awsToken || ""}|${token.tradingToken || ""}|${token.swapToken || ""}|${token.traderToken || ""}`,
            };
            return { url: urlWithCommonParam, headers };
        }))
            .pipe((0, operators_1.mergeMap)((getReqInfo) => {
            const { url, headers } = getReqInfo;
            return trade_utils_lib_1.ObservableUtils.createGetRequestObservable(url, headers, (response) => response);
        }), (0, operators_1.catchError)((error, e) => {
            if ((error === null || error === void 0 ? void 0 : error.code) === 40101632) {
                (0, trade_token_lib_1.acquireKeyResolver)().tradingTokenManager.updateAccessToken();
            }
            return (0, rxjs_1.throwError)(error);
        }))
            .pipe((0, operators_1.map)((result) => {
            return (0, Transform_1.formatBalanceData)(result, apiKey);
        }));
    }
    getSpotBalanceV2$(apiKey) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().pionexSpotApiHost}/balance/`;
        const requestSigner = (0, trade_token_lib_1.acquireKeyResolver)().requestSigner;
        return requestSigner.getSignRequestV2("GET", url, undefined).pipe((0, operators_1.catchError)((error, e) => {
            if ((error === null || error === void 0 ? void 0 : error.code) === 40101612) {
                (0, trade_token_lib_1.acquireKeyResolver)().tradingTokenManager.updateAccessToken();
            }
            return (0, rxjs_1.throwError)(error);
        }), (0, operators_1.map)((result) => {
            var _a;
            const currencies = (_a = result.data.currencies) !== null && _a !== void 0 ? _a : {};
            const coinList = Object.keys(currencies);
            const spotBalance = coinList.map((coin) => {
                return {
                    balanceType: AssetModels_1.BALANCE_TYPE_V2.TRADE,
                    currency: coin,
                    available: currencies[coin].free,
                    currencyAlias: coin,
                    frozen: currencies[coin].used,
                    balance: currencies[coin].total,
                    btcPrice: 0,
                    btcChangePercent: 0,
                    usdPrice: 0,
                    usdChangePercent: 0,
                };
            });
            return {
                trade: spotBalance,
                debt: [],
                arbitrageStrategy: [],
                swap: [],
                cmSwap: [],
                deposit: [],
                dual: [],
                dualAuto: [],
                moduleFinance: [],
                traderAccount: [],
            };
        }));
    }
    fetchFullBalanceForTradeV2$(apiKey, balanceType) {
        if (apiKey.market === TradeAPILib_1.ExchangeID.PIONEXV2 && balanceType === AssetModels_1.BALANCE_TYPE_V2.TRADE) {
            return this.getSpotBalanceV2$(apiKey);
        }
        return this.getBalanceV2$(apiKey);
    }
    // apis/wapi/v1/balances_stat/
    getBalancesStat$() {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().balanceApiHost}/balances_stat/`;
        return trade_utils_lib_1.ObservableUtils.getV2(url, {}, null, true);
    }
    // apis/wapi/v1/balances_stat/
    getBalancesHistory$(period = AssetModels_1.AssetBalancePeriod.week) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().balanceApiHost}/balances_history/`;
        return trade_utils_lib_1.ObservableUtils.getV2(url, { period }, null, true);
    }
    withdrawCancel(txID, keyInfo) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().walletApiHost}/withdraw/${txID}/`;
        return (0, trade_utils_lib_1.getTradeDependencyInstance)()
            .getTradingToken()
            .pipe((0, operators_1.mergeMap)((res) => {
            const headers = { Authorization: `Bearer ${res.tradingToken || ""}` };
            return trade_utils_lib_1.ObservableUtils.delete(url, undefined, headers, false);
        }));
    }
    transfer(params) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().walletApiHost}/transfer/`;
        return trade_utils_lib_1.ObservableUtils.postWithAccessAndSpotAuth(url, undefined, params);
    }
    /** 获取总资产展示，订单维度 */
    getBalancesFull(app_lang, merge_order_group) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().balanceApiHostV2}/balances_full`;
        return trade_utils_lib_1.NetworkUtils.getWithFullTokenAuth({ url: url, data: { app_lang: app_lang, merge_order_group } });
    }
    /** 获取总资产展示，分组详情 */
    getBalancesFullDetail(params) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().balanceApiHostV2}/balances_full/detail`;
        const { app_lang, type, page_token, merge_order_group } = params;
        return trade_utils_lib_1.NetworkUtils.getWithFullTokenAuth({
            url: url,
            data: { app_lang: app_lang, type: type, page_token: page_token, merge_order_group },
        });
    }
    /** 获取总资产展示，币维度 */
    getBalancesCoins(app_lang) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().balanceApiHostV2}/balances_coin`;
        return trade_utils_lib_1.NetworkUtils.getWithFullTokenAuth({ url: url, data: { app_lang: app_lang } });
    }
}
exports.AssetAPILib = AssetAPILib;
